import { Typography } from "antd";
import { Assets } from "../../assets";
import useAppStore from "../../store/AppStore";

const { Title, Paragraph } = Typography;
export const WelcomePage = () => {
  const { authorizationData } = useAppStore();
  const hour = new Date().getHours();

  const greeting = hour < 18 ? "Bonjour" : "Bonsoir";
  return (
    <div
      className="mt-4"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        background: "#fafafa",
        padding: 24,
        borderRadius: 8,
      }}
    >
      <img
        src={Assets.imagesSvg.logo}
        alt="welcome-illustration"
        style={{ width: 300, marginBottom: 30 }}
      />

      <Title level={2} style={{ marginBottom: 0 }}>
        {greeting} {authorizationData?.user?.fullname}
      </Title>

      <Paragraph style={{ marginTop: 10, maxWidth: 500, color: "#666" }}>
        Nous sommes heureux de vous voir ici ! Explorez vos analyses, gérez vos
        données et accédez à tous vos outils depuis un seul endroit.
      </Paragraph>

      {/* <Button
        type="primary"
        size="large"
        onClick={() => (window.location.href = "/dashboard")}
      >
        Go to Dashboard
      </Button> */}
    </div>
  );
};
